export const DASHBOARD_VERSION = "0.1.0";
export const COMMAND_TYPES = ["start", "stop", "restart", "backup", "status"];
export const STATUS_VALUES = ["running", "idle", "starting", "stopped", "error", "unknown"];
export const LOG_LEVELS = ["info", "warn", "error", "join", "leave", "ready", "pause"];
export function isCommandType(value) {
    return typeof value === "string" && COMMAND_TYPES.includes(value);
}
export function snapshotIsStale(snapshot, staleAfterSeconds, now = Date.now()) {
    if (!snapshot)
        return true;
    return now - Date.parse(snapshot.collectedAt) > staleAfterSeconds * 1000;
}
export function humanBytes(bytes) {
    if (bytes == null || !Number.isFinite(bytes))
        return "unknown";
    const units = ["B", "KB", "MB", "GB", "TB"];
    let value = Math.max(0, bytes);
    let unit = 0;
    while (value >= 1024 && unit < units.length - 1) {
        value /= 1024;
        unit += 1;
    }
    return `${value.toFixed(value >= 10 || unit === 0 ? 0 : 1)} ${units[unit]}`;
}
//# sourceMappingURL=schema.js.map